// Icônes personnalisées dans le style high-tech gouvernemental années 90
export const AlbionIcons = {
    // Icône Tableau d'enquête - Style interface de surveillance high-tech
    Board: ({ size = 32, className = "" }: { size?: number; className?: string }) => (
        <svg width={size} height={size} viewBox="0 0 32 32" className={className}>
            {/* Écran principal */}
            <rect x="4" y="6" width="24" height="18" fill="currentColor" stroke="rgba(255,255,255,0.2)" strokeWidth="1" />
            <rect x="6" y="8" width="20" height="14" fill="rgba(0,0,0,0.8)" />
            
            {/* Grille de données */}
            <rect x="8" y="10" width="16" height="1" fill="currentColor" opacity="0.6" />
            <rect x="8" y="12" width="16" height="1" fill="currentColor" opacity="0.6" />
            <rect x="8" y="14" width="16" height="1" fill="currentColor" opacity="0.6" />
            <rect x="8" y="16" width="16" height="1" fill="currentColor" opacity="0.6" />
            
            {/* Lignes verticales */}
            <rect x="12" y="10" width="1" height="10" fill="currentColor" opacity="0.4" />
            <rect x="16" y="10" width="1" height="10" fill="currentColor" opacity="0.4" />
            <rect x="20" y="10" width="1" height="10" fill="currentColor" opacity="0.4" />
            
            {/* Points de données actifs */}
            <circle cx="10" cy="11" r="1" fill="currentColor" />
            <circle cx="14" cy="13" r="1" fill="currentColor" />
            <circle cx="18" cy="15" r="1" fill="currentColor" />
            <circle cx="22" cy="17" r="1" fill="currentColor" />
            
            {/* Base du terminal */}
            <rect x="12" y="24" width="8" height="4" fill="currentColor" />
            <rect x="10" y="26" width="12" height="2" fill="currentColor" opacity="0.8" />
            
            {/* LED d'état */}
            <circle cx="7" cy="9" r="1" fill="currentColor" className="animate-pulse" />
        </svg>
    ),

    // Icône Explorateur - Style terminal de fichiers
    Folder: ({ size = 32, className = "" }: { size?: number; className?: string }) => (
        <svg width={size} height={size} viewBox="0 0 32 32" className={className}>
            {/* Structure du dossier high-tech */}
            <rect x="4" y="10" width="24" height="16" fill="currentColor" stroke="rgba(255,255,255,0.2)" strokeWidth="1" />
            <rect x="6" y="12" width="20" height="12" fill="rgba(0,0,0,0.7)" />
            
            {/* Onglet */}
            <rect x="4" y="8" width="12" height="4" fill="currentColor" />
            
            {/* Lignes de fichiers */}
            <rect x="8" y="14" width="2" height="1" fill="currentColor" opacity="0.8" />
            <rect x="11" y="14" width="8" height="1" fill="currentColor" opacity="0.6" />
            
            <rect x="8" y="16" width="2" height="1" fill="currentColor" opacity="0.8" />
            <rect x="11" y="16" width="6" height="1" fill="currentColor" opacity="0.6" />
            
            <rect x="8" y="18" width="2" height="1" fill="currentColor" opacity="0.8" />
            <rect x="11" y="18" width="10" height="1" fill="currentColor" opacity="0.6" />
            
            <rect x="8" y="20" width="2" height="1" fill="currentColor" opacity="0.8" />
            <rect x="11" y="20" width="7" height="1" fill="currentColor" opacity="0.6" />
            
            {/* Indicateur d'accès */}
            <rect x="24" y="14" width="2" height="8" fill="currentColor" opacity="0.4" />
            <circle cx="25" cy="16" r="0.5" fill="currentColor" />
        </svg>
    ),

    // Icône Terminal - Style console système
    Terminal: ({ size = 32, className = "" }: { size?: number; className?: string }) => (
        <svg width={size} height={size} viewBox="0 0 32 32" className={className}>
            {/* Écran terminal */}
            <rect x="4" y="6" width="24" height="18" fill="currentColor" stroke="rgba(255,255,255,0.2)" strokeWidth="1" />
            <rect x="6" y="8" width="20" height="14" fill="rgba(0,0,0,0.9)" />
            
            {/* Lignes de code */}
            <rect x="8" y="10" width="1" height="1" fill="currentColor" />
            <rect x="10" y="10" width="4" height="1" fill="currentColor" opacity="0.8" />
            <rect x="15" y="10" width="6" height="1" fill="currentColor" opacity="0.6" />
            
            <rect x="8" y="12" width="8" height="1" fill="currentColor" opacity="0.7" />
            <rect x="17" y="12" width="3" height="1" fill="currentColor" opacity="0.5" />
            
            <rect x="8" y="14" width="2" height="1" fill="currentColor" />
            <rect x="11" y="14" width="7" height="1" fill="currentColor" opacity="0.6" />
            
            <rect x="8" y="16" width="5" height="1" fill="currentColor" opacity="0.8" />
            
            {/* Curseur clignotant */}
            <rect x="8" y="18" width="1" height="1" fill="currentColor" className="animate-pulse" />
            
            {/* Base */}
            <rect x="12" y="24" width="8" height="3" fill="currentColor" />
            <rect x="10" y="26" width="12" height="2" fill="currentColor" opacity="0.8" />
        </svg>
    ),

    // Icône Messenger - Style communicateur militaire
    Messenger: ({ size = 32, className = "" }: { size?: number; className?: string }) => (
        <svg width={size} height={size} viewBox="0 0 32 32" className={className}>
            {/* Corps du communicateur */}
            <rect x="8" y="4" width="16" height="22" fill="currentColor" stroke="rgba(255,255,255,0.2)" strokeWidth="1" />
            
            {/* Écran */}
            <rect x="10" y="8" width="12" height="8" fill="rgba(0,0,0,0.8)" />
            
            {/* Messages simulés */}
            <rect x="11" y="10" width="6" height="1" fill="currentColor" opacity="0.7" />
            <rect x="11" y="12" width="8" height="1" fill="currentColor" opacity="0.5" />
            <rect x="11" y="14" width="4" height="1" fill="currentColor" opacity="0.6" />
            
            {/* Antenne */}
            <rect x="15.5" y="2" width="1" height="4" fill="currentColor" />
            <circle cx="16" cy="1" r="1" fill="currentColor" />
            
            {/* Grille de haut-parleur */}
            <rect x="10" y="18" width="12" height="1" fill="currentColor" opacity="0.3" />
            <rect x="10" y="20" width="12" height="1" fill="currentColor" opacity="0.3" />
            <rect x="10" y="22" width="12" height="1" fill="currentColor" opacity="0.3" />
            
            {/* LED de statut */}
            <circle cx="20" cy="6" r="1" fill="currentColor" className="animate-pulse" />
        </svg>
    ),

    // Icône L'Oreille - Style équipement d'écoute
    Radio: ({ size = 32, className = "" }: { size?: number; className?: string }) => (
        <svg width={size} height={size} viewBox="0 0 32 32" className={className}>
            {/* Corps du récepteur */}
            <rect x="6" y="10" width="20" height="14" fill="currentColor" stroke="rgba(255,255,255,0.2)" strokeWidth="1" />
            
            {/* Écran de fréquence */}
            <rect x="8" y="12" width="16" height="4" fill="rgba(0,0,0,0.8)" />
            
            {/* Affichage fréquence */}
            <rect x="10" y="13" width="2" height="1" fill="currentColor" opacity="0.8" />
            <rect x="13" y="13" width="1" height="1" fill="currentColor" opacity="0.6" />
            <rect x="15" y="13" width="3" height="1" fill="currentColor" opacity="0.7" />
            <rect x="19" y="13" width="2" height="1" fill="currentColor" opacity="0.5" />
            
            {/* Indicateur de signal */}
            <rect x="20" y="14" width="1" height="1" fill="currentColor" />
            <rect x="21" y="14" width="1" height="1" fill="currentColor" opacity="0.7" />
            <rect x="22" y="14" width="1" height="1" fill="currentColor" opacity="0.4" />
            
            {/* Contrôles */}
            <circle cx="10" cy="19" r="1.5" fill="currentColor" opacity="0.6" />
            <circle cx="16" cy="19" r="1.5" fill="currentColor" opacity="0.6" />
            <circle cx="22" cy="19" r="1.5" fill="currentColor" opacity="0.6" />
            
            {/* Antenne */}
            <rect x="25" y="6" width="1" height="8" fill="currentColor" />
            <rect x="24" y="4" width="1" height="6" fill="currentColor" opacity="0.7" />
            
            {/* Ondes */}
            <path d="M28 8 Q30 10 28 12" fill="none" stroke="currentColor" strokeWidth="1" opacity="0.6" />
            <path d="M29 6 Q32 10 29 14" fill="none" stroke="currentColor" strokeWidth="1" opacity="0.4" />
        </svg>
    ),

    // Icône Poste de travail - Style station high-tech
    Computer: ({ size = 32, className = "" }: { size?: number; className?: string }) => (
        <svg width={size} height={size} viewBox="0 0 32 32" className={className}>
            {/* Tour principale */}
            <rect x="10" y="8" width="12" height="18" fill="currentColor" stroke="rgba(255,255,255,0.2)" strokeWidth="1" />
            
            {/* Panneaux avant */}
            <rect x="12" y="10" width="8" height="2" fill="rgba(0,0,0,0.6)" />
            <rect x="12" y="13" width="8" height="2" fill="rgba(0,0,0,0.6)" />
            
            {/* LED système */}
            <circle cx="13" cy="17" r="0.5" fill="currentColor" className="animate-pulse" />
            <circle cx="15" cy="17" r="0.5" fill="currentColor" opacity="0.6" />
            
            {/* Grilles d'aération */}
            <rect x="12" y="20" width="8" height="1" fill="rgba(0,0,0,0.4)" />
            <rect x="12" y="22" width="8" height="1" fill="rgba(0,0,0,0.4)" />
            <rect x="12" y="24" width="8" height="1" fill="rgba(0,0,0,0.4)" />
            
            {/* Connecteurs */}
            <rect x="18" y="18" width="2" height="1" fill="currentColor" opacity="0.7" />
            <rect x="18" y="20" width="2" height="1" fill="currentColor" opacity="0.7" />
            
            {/* Câbles de données */}
            <path d="M22 20 Q26 22 24 26" fill="none" stroke="currentColor" strokeWidth="1" opacity="0.5" />
        </svg>
    ),

    // Icône Corbeille - Style conteneur de données
    Trash: ({ size = 32, className = "" }: { size?: number; className?: string }) => (
        <svg width={size} height={size} viewBox="0 0 32 32" className={className}>
            {/* Corps de la corbeille */}
            <rect x="8" y="12" width="16" height="14" fill="currentColor" stroke="rgba(255,255,255,0.2)" strokeWidth="1" />
            
            {/* Couvercle */}
            <rect x="6" y="10" width="20" height="2" fill="currentColor" />
            
            {/* Poignée */}
            <rect x="12" y="8" width="8" height="2" fill="none" stroke="currentColor" strokeWidth="1" />
            <rect x="12" y="6" width="8" height="2" fill="currentColor" opacity="0.6" />
            
            {/* Lignes de données supprimées */}
            <rect x="12" y="15" width="1" height="8" fill="currentColor" opacity="0.4" />
            <rect x="16" y="15" width="1" height="8" fill="currentColor" opacity="0.4" />
            <rect x="20" y="15" width="1" height="8" fill="currentColor" opacity="0.4" />
            
            {/* Indicateur de contenu */}
            <rect x="10" y="17" width="12" height="1" fill="currentColor" opacity="0.3" />
            <rect x="10" y="19" width="8" height="1" fill="currentColor" opacity="0.3" />
            <rect x="10" y="21" width="10" height="1" fill="currentColor" opacity="0.3" />
        </svg>
    )
};